// import { data } from "flickity"

export default function(){
    const burgerMenu = document.querySelector('.js-burger');
    const headerMobile = document.querySelector('.header-mobile');
    burgerMenu.addEventListener('click', burger =>{
        burger.preventDefault()
        let triggerMenu = burger.currentTarget
        triggerMenu.classList.toggle('active')
        headerMobile.classList.toggle('active')
        document.body.classList.toggle('overflow-hidden')
    })

    const mainMenuMobile = document.querySelectorAll('.main-menu-mobile')
    mainMenuMobile.forEach(main => {
        main.addEventListener('click', menu => {
            let mainMenu = menu.currentTarget
            let subMenuContainer = mainMenu.nextElementSibling
            let subMenuHeight = subMenuContainer.querySelector('.menu-items-children').clientHeight
            if(mainMenu.classList.contains('active')){
                mainMenu.classList.remove('active')
                subMenuContainer.style.height = '0px'
            }else{
                mainMenu.classList.add('active')
                subMenuContainer.style.height = subMenuHeight + 'px'
            }
        })  
    });
}